import {
  AgxColumn,
  CampaignDetailModel,
  CampaignStage,
} from '@urbanx/agx-ui-components';
import { getEnumValue } from 'helpers/enumHelper';
import { Tabs } from 'types/Tabs';
import AgencyAgreementInfoPanel from './AgencyAgreement/AgencyAgreementInfoPanel';
import AgencyAgreementSubmissionInfoPanel from './AgencyAgreementSubmission/AgencyAgreementSubmissionInfoPanel';
import ListingsPanel from './Listing/ListingsPanel';
import './CampaignInfoPanel.scss';
import { useMemo, useState, useEffect } from 'react';
import clsx from 'clsx';

interface CampaignInfoPanelProps {
  campaign?: CampaignDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const CampaignInfoPanel = ({
  campaign,
  currentTab,
  mobile = false,
}: CampaignInfoPanelProps) => {
  const [visible, setVisible] = useState(false);
  const [currentCampaignId, setCurrentCampaignId] = useState<
    string | undefined
  >(campaign?.campaignId);

  const infoPanel = useMemo(() => {
    if (!campaign) {
      return <></>;
    }
    const { stage } = campaign;

    switch (getEnumValue(CampaignStage, stage)) {
      case CampaignStage.AgreementDraft:
      case CampaignStage.AgreementAgentSigning:
      case CampaignStage.AgreementVendorSigning:
      case CampaignStage.AgreementSignedByAllParties:
        return (
          <AgencyAgreementInfoPanel
            currentTab={currentTab}
            campaign={campaign}
            mobile={mobile}
          />
        );
      case CampaignStage.AgreementSubmissionIncomplete:
        return (
          <AgencyAgreementSubmissionInfoPanel
            campaign={campaign}
            mobile={mobile}
            currentTab={currentTab}
          />
        );
      case CampaignStage.ListingCurrent:
      case CampaignStage.ListingUnderContract:
      case CampaignStage.ListingWithdrawn:
      case CampaignStage.ListingSold:
        return (
          <ListingsPanel
            campaign={campaign}
            mobile={mobile}
            currentTab={currentTab}
          />
        );
      default:
        return <></>;
    }
  }, [campaign]);

  const fadeIn = () => {
    setCurrentCampaignId(campaign?.campaignId);
    setVisible(false);

    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  };

  useEffect(() => {
    return fadeIn();
  }, []);

  useEffect(() => {
    if (currentCampaignId === campaign?.campaignId) return;

    return fadeIn();
  }, [campaign]);

  return (
    <div className={clsx('campaignInfoPanel', visible && 'visible')}>
      <AgxColumn extraClasses={clsx('infoPanelContent', visible && 'visible')}>
        {infoPanel}
      </AgxColumn>
    </div>
  );
};

export default CampaignInfoPanel;
